import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RegisterPasswordComponent } from './pages/register-password/register-password.component';

const routes: Routes = [
	{
		path: 'register-password',
		component: RegisterPasswordComponent,
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
